/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import _Steps from './steps.js';
import _StepItem from './step-item.js';
import mapProps from '../utils/map-props.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './type.js';
import '../_chunks/dep-9d6f3de6.js';
import '@babel/runtime/helpers/defineProperty';
import './props.js';
import '../utils/mixins.js';
import 'vue';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../utils/event.js';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/camelCase';
import 'lodash/isFunction';
import 'tdesign-icons-vue';
import './step-item-props.js';
import '../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/kebabCase';
import 'lodash/capitalize';

var StepItem = withInstall(_StepItem);
var Steps = withInstall(mapProps(["current"], {
  model: {
    prop: "current",
    event: "change"
  }
})(_Steps));

export { StepItem, Steps, Steps as default };
//# sourceMappingURL=index.js.map
